export default __webpack_public_path__ + "static/media/catalogo_scifood_v2.e0057f75.pdf";